module.exports = {
	"config": {
		"siteTitle": "SORAVIS",
		"linkPrefix": "/gatsby-starter-default",
		"enableBlog": false,
		"enableLife": false,
		"googleAnalyticsId": "UA-72985104-3"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx",
				"absolute": "/Users/Sun/Projects/20_SunPortfolio/Development/soravis-gatsby/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.html",
				"ext": "html",
				"name": "404",
				"extname": ".html",
				"basename": "404.html",
				"dirname": "",
				"stem": "404",
				"path": "404.html",
				"absolute": "/Users/Sun/Projects/20_SunPortfolio/Development/soravis-gatsby/404.html",
				"isAbsolute": false
			},
			"requirePath": "404.html",
			"path": "/404/",
			"data": {
				"body": "<div class=\"notfound-404\">\n<h1>404</h1>\n<p>Page not found.</p>\n<img src=\"/images/404.png\" />\n<p>Someone might have broken the space-time continuum...<p>\n</div>\n"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "about.js",
				"ext": "js",
				"name": "about",
				"extname": ".js",
				"basename": "about.js",
				"dirname": "",
				"stem": "about",
				"path": "about.js",
				"absolute": "/Users/Sun/Projects/20_SunPortfolio/Development/soravis-gatsby/about.js",
				"isAbsolute": false
			},
			"requirePath": "about.js",
			"path": "/about/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "blog-store",
				"base": "_legacyindex.js",
				"ext": "js",
				"name": "_legacyindex",
				"extname": ".js",
				"basename": "_legacyindex.js",
				"dirname": "blog-store",
				"stem": "_legacyindex",
				"path": "blog-store/_legacyindex.js",
				"absolute": "/Users/Sun/Projects/20_SunPortfolio/Development/soravis-gatsby/blog-store/_legacyindex.js",
				"isAbsolute": false
			},
			"requirePath": "blog-store/_legacyindex.js",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "blog-store/2016-11-20-gatsbyjs-for-portfolio-site",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "blog-store/2016-11-20-gatsbyjs-for-portfolio-site",
				"stem": "index",
				"path": "blog-store/2016-11-20-gatsbyjs-for-portfolio-site/index.md",
				"absolute": "/Users/Sun/Projects/20_SunPortfolio/Development/soravis-gatsby/blog-store/2016-11-20-gatsbyjs-for-portfolio-site/index.md",
				"isAbsolute": false
			},
			"requirePath": "blog-store/2016-11-20-gatsbyjs-for-portfolio-site/index.md",
			"path": "/blog/gatsby-js-for-portfolio-site/",
			"data": {
				"title": "Why GatsbyJS is ideal for a portfolio site.",
				"date": "2016-11-20T22:00:00.000Z",
				"thumb": "cover-01.jpg",
				"layout": "postyay",
				"readNext": "/my-second-post/",
				"path": "/blog/gatsby-js-for-portfolio-site/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "blog.js",
				"ext": "js",
				"name": "blog",
				"extname": ".js",
				"basename": "blog.js",
				"dirname": "",
				"stem": "blog",
				"path": "blog.js",
				"absolute": "/Users/Sun/Projects/20_SunPortfolio/Development/soravis-gatsby/blog.js",
				"isAbsolute": false
			},
			"requirePath": "blog.js",
			"path": "/blog/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "html.html",
				"ext": "html",
				"name": "html",
				"extname": ".html",
				"basename": "html.html",
				"dirname": "",
				"stem": "html",
				"path": "html.html",
				"absolute": "/Users/Sun/Projects/20_SunPortfolio/Development/soravis-gatsby/html.html",
				"isAbsolute": false
			},
			"requirePath": "html.html",
			"path": "/html/",
			"data": {
				"title": "HTML <u>still</u> ROCKS!",
				"body": "<!--\ntitle: HTML <u>still</u> ROCKS!\n-->\n<p>You can also author content in raw HTML if that's your flavoring. Gatsby handles\nthat just fine.</p>\n"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "",
				"stem": "index",
				"path": "index.js",
				"absolute": "/Users/Sun/Projects/20_SunPortfolio/Development/soravis-gatsby/index.js",
				"isAbsolute": false
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "json.json",
				"ext": "json",
				"name": "json",
				"extname": ".json",
				"basename": "json.json",
				"dirname": "",
				"stem": "json",
				"path": "json.json",
				"absolute": "/Users/Sun/Projects/20_SunPortfolio/Development/soravis-gatsby/json.json",
				"isAbsolute": false
			},
			"requirePath": "json.json",
			"path": "/json/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "markdown.md",
				"ext": "md",
				"name": "markdown",
				"extname": ".md",
				"basename": "markdown.md",
				"dirname": "",
				"stem": "markdown",
				"path": "markdown.md",
				"absolute": "/Users/Sun/Projects/20_SunPortfolio/Development/soravis-gatsby/markdown.md",
				"isAbsolute": false
			},
			"requirePath": "markdown.md",
			"path": "/markdown/",
			"data": {
				"title": "I'm a markdown file!"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "music.js",
				"ext": "js",
				"name": "music",
				"extname": ".js",
				"basename": "music.js",
				"dirname": "",
				"stem": "music",
				"path": "music.js",
				"absolute": "/Users/Sun/Projects/20_SunPortfolio/Development/soravis-gatsby/music.js",
				"isAbsolute": false
			},
			"requirePath": "music.js",
			"path": "/music/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "react.js",
				"ext": "js",
				"name": "react",
				"extname": ".js",
				"basename": "react.js",
				"dirname": "",
				"stem": "react",
				"path": "react.js",
				"absolute": "/Users/Sun/Projects/20_SunPortfolio/Development/soravis-gatsby/react.js",
				"isAbsolute": false
			},
			"requirePath": "react.js",
			"path": "/react/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "toml.toml",
				"ext": "toml",
				"name": "toml",
				"extname": ".toml",
				"basename": "toml.toml",
				"dirname": "",
				"stem": "toml",
				"path": "toml.toml",
				"absolute": "/Users/Sun/Projects/20_SunPortfolio/Development/soravis-gatsby/toml.toml",
				"isAbsolute": false
			},
			"requirePath": "toml.toml",
			"path": "/toml/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "works/brand-x-line-hack",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "works/brand-x-line-hack",
				"stem": "index",
				"path": "works/brand-x-line-hack/index.jsx",
				"absolute": "/Users/Sun/Projects/20_SunPortfolio/Development/soravis-gatsby/works/brand-x-line-hack/index.jsx",
				"isAbsolute": false
			},
			"requirePath": "works/brand-x-line-hack/index.jsx",
			"path": "/works/brand-x-line-hack/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "works/digimagic-projects",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "works/digimagic-projects",
				"stem": "index",
				"path": "works/digimagic-projects/index.js",
				"absolute": "/Users/Sun/Projects/20_SunPortfolio/Development/soravis-gatsby/works/digimagic-projects/index.js",
				"isAbsolute": false
			},
			"requirePath": "works/digimagic-projects/index.js",
			"path": "/works/digimagic-projects/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "works",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "works",
				"stem": "index",
				"path": "works/index.js",
				"absolute": "/Users/Sun/Projects/20_SunPortfolio/Development/soravis-gatsby/works/index.js",
				"isAbsolute": false
			},
			"requirePath": "works/index.js",
			"path": "/works/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "works/inline-at-line-hack",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "works/inline-at-line-hack",
				"stem": "index",
				"path": "works/inline-at-line-hack/index.jsx",
				"absolute": "/Users/Sun/Projects/20_SunPortfolio/Development/soravis-gatsby/works/inline-at-line-hack/index.jsx",
				"isAbsolute": false
			},
			"requirePath": "works/inline-at-line-hack/index.jsx",
			"path": "/works/inline-at-line-hack/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "works/meditech-senze",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "works/meditech-senze",
				"stem": "index",
				"path": "works/meditech-senze/index.jsx",
				"absolute": "/Users/Sun/Projects/20_SunPortfolio/Development/soravis-gatsby/works/meditech-senze/index.jsx",
				"isAbsolute": false
			},
			"requirePath": "works/meditech-senze/index.jsx",
			"path": "/works/meditech-senze/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "works/microbrik",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "works/microbrik",
				"stem": "index",
				"path": "works/microbrik/index.jsx",
				"absolute": "/Users/Sun/Projects/20_SunPortfolio/Development/soravis-gatsby/works/microbrik/index.jsx",
				"isAbsolute": false
			},
			"requirePath": "works/microbrik/index.jsx",
			"path": "/works/microbrik/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "works/mobile-reality-boxing",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "works/mobile-reality-boxing",
				"stem": "index",
				"path": "works/mobile-reality-boxing/index.js",
				"absolute": "/Users/Sun/Projects/20_SunPortfolio/Development/soravis-gatsby/works/mobile-reality-boxing/index.js",
				"isAbsolute": false
			},
			"requirePath": "works/mobile-reality-boxing/index.js",
			"path": "/works/mobile-reality-boxing/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "works/osmep-business-intelligence",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "works/osmep-business-intelligence",
				"stem": "index",
				"path": "works/osmep-business-intelligence/index.jsx",
				"absolute": "/Users/Sun/Projects/20_SunPortfolio/Development/soravis-gatsby/works/osmep-business-intelligence/index.jsx",
				"isAbsolute": false
			},
			"requirePath": "works/osmep-business-intelligence/index.jsx",
			"path": "/works/osmep-business-intelligence/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "works/osmep-sme-tracking",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "works/osmep-sme-tracking",
				"stem": "index",
				"path": "works/osmep-sme-tracking/index.jsx",
				"absolute": "/Users/Sun/Projects/20_SunPortfolio/Development/soravis-gatsby/works/osmep-sme-tracking/index.jsx",
				"isAbsolute": false
			},
			"requirePath": "works/osmep-sme-tracking/index.jsx",
			"path": "/works/osmep-sme-tracking/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "works/resus-ultrasound",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "works/resus-ultrasound",
				"stem": "index",
				"path": "works/resus-ultrasound/index.jsx",
				"absolute": "/Users/Sun/Projects/20_SunPortfolio/Development/soravis-gatsby/works/resus-ultrasound/index.jsx",
				"isAbsolute": false
			},
			"requirePath": "works/resus-ultrasound/index.jsx",
			"path": "/works/resus-ultrasound/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "works/runnables-branding-kit",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "works/runnables-branding-kit",
				"stem": "index",
				"path": "works/runnables-branding-kit/index.jsx",
				"absolute": "/Users/Sun/Projects/20_SunPortfolio/Development/soravis-gatsby/works/runnables-branding-kit/index.jsx",
				"isAbsolute": false
			},
			"requirePath": "works/runnables-branding-kit/index.jsx",
			"path": "/works/runnables-branding-kit/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "works/skinspiel",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "works/skinspiel",
				"stem": "index",
				"path": "works/skinspiel/index.js",
				"absolute": "/Users/Sun/Projects/20_SunPortfolio/Development/soravis-gatsby/works/skinspiel/index.js",
				"isAbsolute": false
			},
			"requirePath": "works/skinspiel/index.js",
			"path": "/works/skinspiel/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "works/ucheckpoint",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "works/ucheckpoint",
				"stem": "index",
				"path": "works/ucheckpoint/index.jsx",
				"absolute": "/Users/Sun/Projects/20_SunPortfolio/Development/soravis-gatsby/works/ucheckpoint/index.jsx",
				"isAbsolute": false
			},
			"requirePath": "works/ucheckpoint/index.jsx",
			"path": "/works/ucheckpoint/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "yaml.yaml",
				"ext": "yaml",
				"name": "yaml",
				"extname": ".yaml",
				"basename": "yaml.yaml",
				"dirname": "",
				"stem": "yaml",
				"path": "yaml.yaml",
				"absolute": "/Users/Sun/Projects/20_SunPortfolio/Development/soravis-gatsby/yaml.yaml",
				"isAbsolute": false
			},
			"requirePath": "yaml.yaml",
			"path": "/yaml/",
			"data": {}
		}
	]
}


/*****************
 ** WEBPACK FOOTER
 ** ../config.toml
 ** module id = 376
 ** module chunks = 0
 **/